namespace Vit.Reports
{
    export interface IDataSourceOption {
        contentType?: string;
        url?: string;
        method?: string;
        data?: string;
    }
}